import { createContext, useContext, useState } from 'react'
import { insumoService } from '../services/insumoService'
import { useNavigate } from 'react-router'
import { useUtiles } from './utilesContext'
import * as XLSX from 'xlsx'
import Swal from 'sweetalert2'
export const InsumoContext = createContext()

export const useInsumo = () => {
    return useContext(InsumoContext)
}

export const InsumoProvider = ({ children }) => {

    const navigate = useNavigate()
    const { setAlertSnackbar, restorePreviousComponent } = useUtiles()

    const [insumo, setInsumo] = useState({
        location: '',
        name: '',
        code: '',
        amount: 0,
        type_insumo: '',
        classification1: '',
        classification2: '',
        unit: '',
        description: '',
        date_entry: '',

    })

    const resetInsumo = () => {
        setInsumo({
            location: '',
            name: '',
            code: '',
            amount: 0,
            type_insumo: '',
            classification1: '',
            classification2: '',
            unit: '',
            description: '',
            date_entry: '',
        })
    }


    const setSelectLocationParent = (location) => {
        setInsumo( (prev) => ({ ...prev, location: location}))
    }

    const setSelectClassification1 = (classification) => {
        setInsumo( (prev) => ({ ...prev, classification1: classification}))
    }

    const setSelectClassification2 = (classification) => {
        setInsumo( (prev) => ({ ...prev, classification2: classification}))
    }

    const setSelectTypeInsumo = (typeInsumo) => {
        setInsumo( (prev) => ({ ...prev, type_insumo: typeInsumo}))
    }

    /**
     * GESTIÓN DE TIPOS DE INSUMOS
     */

    const [typeInsumos, setTypeInsumos] = useState([])
    const [loadingTypeInsumos, setLoadingTypeInsumos] = useState(false)
    const getTypeInsumos = async (params) => {
        try {
            setLoadingTypeInsumos(true)
            const response = await insumoService.getTypeInsumos(params)
            setTypeInsumos(response.data)
            console.log(response.data)
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingTypeInsumos(false)
        }
    }

    const [loadingCreateTypeInsumo, setLoadingCreateTypeInsumo] = useState(false) 
    const createTypeInsumo = async (typeInsumo) => {
        try {
            setLoadingCreateTypeInsumo(true)
            const response = await insumoService.createTypeInsumo(typeInsumo)
            await getTypeInsumos()
            setAlertSnackbar({  
                open: true,
                message: 'Tipo de insumo creado correctamente',
                severity: 'success'
            })
            restorePreviousComponent()
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        } finally {
            setLoadingCreateTypeInsumo(false)
        }
    }

    /**
     * CREAR INSUMO
     */

    const [loadingCreateInsumo, setLoadingCreateInsumo] = useState(false)
    const createInsumo = async () => {
        try {
            setLoadingCreateInsumo(true)

            //obtener solo los id de location, classification1, classification2 y type_insumo    
            const data = { ...insumo, 
                location: insumo.location ? insumo.location.id : null, 
                classification1: insumo.classification1 ? insumo.classification1.id : null, 
                classification2: insumo.classification2 ? insumo.classification2.id : null, 
                type_insumo: insumo.type_insumo ? insumo.type_insumo.id : null 
            }
            const response = await insumoService.createInsumo(data)
            resetInsumo()
            navigate('/insumos')
            setAlertSnackbar({
                open: true,
                message: 'Insumo creado correctamente',
                severity: 'success'
            })
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        } finally {
            setLoadingCreateInsumo(false)
        }   
    }

    /**
     * ACTUALIZAR INSUMO
     */

    const [loadingUpdateInsumo, setLoadingUpdateInsumo] = useState(false)
    const updateInsumo = async () => {
        try {
            setLoadingUpdateInsumo(true)
            //obtener solo los id de location, classification1, classification2 y type_insumo    
            const data = { ...insumo, 
                location: insumo.location ? insumo.location.id : null, 
                classification1: insumo.classification1 ? insumo.classification1.id : null, 
                classification2: insumo.classification2 ? insumo.classification2.id : null, 
                type_insumo: insumo.type_insumo ? insumo.type_insumo.id : null 
            }
            const response = await insumoService.updateInsumo(data)
            resetInsumo()
            navigate('/insumos')
            setAlertSnackbar({
                open: true,
                message: 'Insumo actualizado correctamente',
                severity: 'success'
            })
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        } finally {
            setLoadingUpdateInsumo(false)
        }
    }

    /**
     * LISTAR INSUMOS
     */

    const [loadingGetInsumos, setLoadingGetInsumos] = useState(false)
    const [insumos, setInsumos] = useState([])

    
    const [pagination, setPagination] = useState({})

    const [filtersData, setFiltersData] = useState({})

    const getInsumos = async (filters) => {
        try {
            setLoadingGetInsumos(true)
            const data = { ...filters, ...filtersData }
            const response = await insumoService.getInsumos(data)
            setInsumos(response.data.insumos)
            setPagination(response.data.pagination)
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingGetInsumos(false)
        }
    }


    const [loadingInsumoByCode, setLoadingInsumoByCode] = useState(false)
    const [insumosByCode, setInsumosByCode] = useState([])
    const getInsumoByCode = async (codeName, isActive = true) => {
        setLoadingInsumoByCode(true)
        try{
            const response = await insumoService.getInsumos({codeName, is_active: isActive})
            setInsumosByCode(response.data.insumos)
        }catch(error){
            console.log(error)

        }finally{
            setLoadingInsumoByCode(false)
        }
    }

  

    /**
     * CARGAR INSUMOS MASIVOS
     */

    const [loadingUploadMasive, setLoadingUploadMasive] = useState(false)
    const [dataMasive, setDataMasive] = useState(null)
    const [responseMasive, setResponseMasive] = useState(null)

    const loadMasiveInsumos = async (files) => {
        try{
            setLoadingUploadMasive(true)    
            const file = files[0]
            const reader = new FileReader()

            reader.onload = (event) => {
                const arrayBuffer = event.target.result;
                const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const data = XLSX.utils.sheet_to_json(worksheet);
                
                // Convertir fechas de Excel a formato ISO (YYYY-MM-DD)
                const processedData = data.map(item => {
                    const newItem = { ...item };
                    
                    // Procesar date_entry si existe y es un número (serial de Excel)
                    if (newItem.date_entry !== undefined && newItem.date_entry !== null) {
                        // Si es un número de serie de Excel
                        if (typeof newItem.date_entry === 'number' || !isNaN(Number(newItem.date_entry))) {
                            // Convertir el número de serie de Excel a una fecha JavaScript
                            const excelEpoch = new Date(1899, 11, 30); // Excel epoch (December 30, 1899)
                            const serialNumber = Number(newItem.date_entry);
                            const daysSinceEpoch = serialNumber; // Excel usa días desde la fecha base
                            
                            // Calcular la fecha sumando los días a la fecha base
                            const date = new Date(excelEpoch);
                            date.setDate(date.getDate() + daysSinceEpoch);
                            
                            // Formatear la fecha en ISO YYYY-MM-DD
                            newItem.date_entry = date.toISOString().split('T')[0];
                        }
                    }
                    
                    return newItem;
                });
                
                console.log(processedData);
                setDataMasive(processedData);
              };
              
              reader.readAsArrayBuffer(file);
        }catch(error){
            console.log(error)
        }finally{   
            setLoadingUploadMasive(false)
        }
    }

    const [loadingMasive, setLoadingMasive] = useState(false)
    const processMasiveInsumos = async () => {
        setLoadingMasive(true)
        try{
            
            const response = await insumoService.createInsumoMasive(dataMasive)
            setResponseMasive(response.data)
            setDataMasive(null)
            await getInsumos()
            console.log(response.data)

            setAlertSnackbar({
                open: true,
                message: "Insumos procesados correctamente",
                severity: 'success'
            })
        }catch(error){
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: "Ocurrió un error al procesar los insumos",
                severity: 'error'
            })
        }finally{
            setLoadingMasive(false)
        }
    }


    const [selectedInsumoToEnable, setSelectedInsumoToEnable] = useState([])
    const [selectedInsumoToDelete, setSelectedInsumoToDelete] = useState([])
    /**
     * ELIMINAR INSUMOS
     */

    const [loadingDeleteInsumos, setLoadingDeleteInsumos] = useState(false)
    const deleteInsumos = async () => {
        try{
            const confirm = await Swal.fire({
                title: '¿Estás seguro?',
                text: 'No podrás revertir esto',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
            })
            if(!confirm.isConfirmed){
                return
            }
            setLoadingDeleteInsumos(true)
            const response = await insumoService.deleteInsumos(selectedInsumoToDelete)
            console.log(selectedInsumoToDelete)
            await getInsumos()
            setSelectedInsumoToDelete([])
            setAlertSnackbar({
                open: true,
                message: "Insumos eliminados correctamente",
                severity: 'success'
            })
        }catch(error){
            console.log(error)
        }finally{
            setLoadingDeleteInsumos(false)
        }
    }

    /**
     * OBTENER INSUMO POR HASH
     */

    const [loadingGetInsumoByHash, setLoadingGetInsumoByHash] = useState(false)
    const getInsumoByHash = async (hash) => {
        setLoadingGetInsumoByHash(true)
        try{
            const response = await insumoService.getInsumoByHash(hash)
            // formatear fecha de entrada
            // Si ya viene en formato YYYY-MM-DD, lo usamos directamente
            // Si no, lo convertimos a ese formato
           
            setInsumo(response.data) 
            setAlertSnackbar({
                open: true,
                message: "Insumo obtenido correctamente",
                severity: 'success'
            })
        }catch(error){
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: "Ocurrió un error al obtener el insumo",
                severity: 'error'
            })
        }finally{
            setLoadingGetInsumoByHash(false)
        }
    }

    /**
     * GESTIÓN DE STOCK
     */
    
    const [loadingUpdateStock, setLoadingUpdateStock] = useState(false)
    const updateStock = async (insumoId, quantity, type, notes) => {
        try {
            setLoadingUpdateStock(true)
            const data = {
                insumo_id: insumoId,
                quantity,
                type,
                notes
            }
            const response = await insumoService.updateStock(data)
            await getInsumos()
            setAlertSnackbar({
                open: true,
                message: 'Stock actualizado correctamente',
                severity: 'success'
            })
            
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response?.data?.message || 'Error al actualizar stock',
                severity: 'error'
            })
            throw error
        } finally {
            setLoadingUpdateStock(false)
        }
    }


    //Aumentar Disminuir Stock
    
    const [loadingIncreaseStock, setLoadingIncreaseStock] = useState(false)
    const [loadingDecreaseStock, setLoadingDecreaseStock] = useState(false)
    const [typeStock, setTypeStock] = useState('salida')
    const increaseStock = async (insumoId, quantity) => {
        try {
            setLoadingIncreaseStock(true)
            const data = {
                insumo_id: insumoId,
                quantity,
                type: typeStock
            }
            const response = await insumoService.increaseStock(data)
            setAlertSnackbar({
                open: true,
                message: 'Stock aumentado correctamente',
                severity: 'success'
            })
            await getInsumoByHash(insumo.hash_code)
            return true
        }catch(error){
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response?.data?.message || 'Error al aumentar stock',
                severity: 'error'
            })
            return false
        }finally{
            setLoadingIncreaseStock(false)
        }
    }

    const decreaseStock = async (insumoId, quantity) => {
        try {
            setLoadingDecreaseStock(true)
            const data = {
                insumo_id: insumoId,
                quantity,
                type: typeStock
            }
            const response = await insumoService.decreaseStock(data)
            setAlertSnackbar({
                open: true,
                message: 'Stock disminuido correctamente',
                severity: 'success'
            })
            await getInsumoByHash(insumo.hash_code)
            return true
        }catch(error){
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response?.data?.message || 'Error al disminuir stock',
                severity: 'error'
            })
            return false
        }finally{
            setLoadingDecreaseStock(false)
        }
    }


    //Obtener historial de insumo
    const [loadingGetInsumoTask, setLoadingGetInsumoTask] = useState(false)
    const [insumoTask, setInsumoTask] = useState([])
    const getInsumoTask = async (hash_code) => {
        setLoadingGetInsumoTask(true)
        try{
            const response = await insumoService.getInsumoTask(hash_code)
            setInsumoTask(response.data)
            console.log(response.data)
        }catch(error){
            console.log(error)
        }
        finally{
            setLoadingGetInsumoTask(false)
        }
    }

    return (
        <InsumoContext.Provider value={{ 
            insumo, 
            setInsumo, 
            resetInsumo, 
            setSelectLocationParent, 
            setSelectClassification1, 
            setSelectClassification2, 
            typeInsumos, 
            getTypeInsumos, 
            loadingTypeInsumos,
            setSelectTypeInsumo,
            createTypeInsumo,
            loadingCreateTypeInsumo,
            setLoadingCreateTypeInsumo,
            createInsumo,
            loadingCreateInsumo,
            getInsumos,
            insumos,
            loadingGetInsumos,
            selectedInsumoToDelete,
            setSelectedInsumoToDelete,
            pagination,
            setPagination,
            loadingUploadMasive,
            dataMasive,
            responseMasive,
            loadMasiveInsumos,
            loadingMasive,
            processMasiveInsumos,
            deleteInsumos,
            loadingDeleteInsumos,
            setDataMasive,
            setResponseMasive,
            loadingGetInsumoByHash,
            getInsumoByHash,
            loadingUpdateInsumo,
            updateInsumo,
            updateStock,
            loadingUpdateStock,
            filtersData,
            setFiltersData,
            selectedInsumoToEnable,
            setSelectedInsumoToEnable,
            loadingInsumoByCode,
            insumosByCode,
            getInsumoByCode,
            loadingIncreaseStock,
            loadingDecreaseStock,
            typeStock,
            setTypeStock,
            increaseStock,
            decreaseStock,
            loadingGetInsumoTask,
            insumoTask,
            getInsumoTask
        }}>
            {children}
        </InsumoContext.Provider>
    )
}
